import { Grid } from '@mui/material'
import type { NoteName, Scale } from '@tunasong/schemas'
import { type FC } from 'react'
import { Note } from './note.js'
import { NoteLib, ScaleLib } from '@tunasong/music-lib'

export interface NoteInfoProps {
  note?: NoteName | null
  scale: Scale
  octave?: number
}

/**
 * NoteInfo shows the note information:
 *
 * - Note name
 * - Note octave
 * - Note interval
 * - Note scale degree
 * - Note enharmonic (e.g. C# = Db)
 * - Note frequency
 */
export const NoteInfo: FC<NoteInfoProps> = props => {
  const { note, scale } = props
  if (!note) {
    return null
  }

  const scaleInterval = ScaleLib.getInterval(scale, note)
  const noteInfo = scaleInterval ? NoteLib.getNoteDegreeInfo(scaleInterval) : null
  const enharmonics = NoteLib.getEnharmonics(note)

  return (
    <Grid container={true} spacing={1}>
      <Grid size={6}>Note</Grid>
      <Grid size={6}>
        <Note note={note} scale={scale} />
      </Grid>

      <Grid size={6}>Enharmonics</Grid>
      <Grid size={6}>{enharmonics.map(n => NoteLib.prettifyNote(n)).join(', ')}</Grid>

      <Grid size={6}>Name</Grid>
      <Grid size={6}>{noteInfo?.name}</Grid>

      <Grid size={6}>Scale degree/interval</Grid>
      <Grid size={6}>{scaleInterval ? NoteLib.prettifyNoteDegree(scaleInterval) : null}</Grid>

      <Grid size={6}>Chromatic interval</Grid>
      <Grid size={6}>{noteInfo?.chromaticDistance}</Grid>
    </Grid>
  )
}

export default NoteInfo
